<template>
  <b-form @submit.stop.prevent="handleSubmit">
    <div class="notes-timeline-form bg-body-dark mb-2">
      <b-form-group
        label="New Note"
        label-for="note-content"
        class="mb-3"
      >
        <v-select
          v-if="quickNoteOptions.length"
          id="note-quick-phrases"
          v-model="quickPhraseSelection"
          :options="quickNoteOptions"
          placeholder="Insert suggested phrases"
          class="mb-2"
          :clearable="true"
          @input="onQuickPhraseInput"
        />
        <b-form-textarea
          id="note-content"
          v-model="$v.form.content.$model"
          :state="$v.form.content.$dirty ? !$v.form.content.$error : null"
          placeholder="Add a note here"
          rows="4"
        />
        <b-form-invalid-feedback
          v-if="$v.form.content.$dirty"
          id="note-content-feedback"
        >
          <span v-if="!$v.form.content.serverFailed">{{ serverErrors.content }}</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <div class="d-flex flex-column flex-md-row align-items-md-center">
        <div class="mb-3 mb-md-0">
          <b-form-checkbox
            id="note-internal"
            v-model="$v.form.internal.$model"
            switch
          >
            Internal note only
          </b-form-checkbox>
          <small class="text-muted d-block mt-1">
            {{ visibilityHelperText }}
          </small>
        </div>

        <div class="ml-md-auto d-flex align-items-center">
          <b-button
            variant="link-dark"
            class="flex-fill px-4"
            @click="handleHide"
          >
            Cancel
          </b-button>
          <b-button
            id="note-submit-button"
            type="submit"
            variant="primary"
            class="flex-fill px-4 ml-2"
            :disabled="!form.content.length"
          >
            Save Note
          </b-button>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
  name: 'NotesTimelineForm',
  mixins: [formMixin],
  props: {
    referenceId: {
      type: Number,
      required: true,
    },
    createFunc: {
      type: Function,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    internal: {
      type: Boolean,
      default: true,
    },
    quickNoteOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        content: this.content,
        internal: this.internal,
      },
      quickPhraseSelection: null,
    };
  },
  computed: {
    visibilityHelperText() {
      return this.form.internal
        ? 'Only SCOPES employees can view this note.'
        : 'This note can be shared with the client.';
    },
  },
  validations: {
    form: {
      content: {
        serverFailed() {
          return !this.hasServerErrors('content');
        },
      },
      internal: {},
    },
  },
  methods: {
    onQuickPhraseInput(value) {
      if (value == null || value === '') {
        return;
      }
      this.form.content = value;
      this.$nextTick(() => {
        this.quickPhraseSelection = null;
      });
    },
    handleHide() {
      this.$emit('on-hide');
    },
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      this.createFunc(this.referenceId, this.form)
        .then((note) => {
          this.$emit('on-save', note);
          this.form.content = '';
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
        });
    }
  },
};
</script>
